import {isLocalStorageAvailable} from '../../../helpers/systemHelpers';
import {ACTIVE_BETS_TAB} from '../constants/identifiers';

export function updateLocalBetsReadStatus(isPlacedBetsElseSettled, gameChannel, state) {
    if (isLocalStorageAvailable) {
        let localBets = sessionStorage.getItem('UNREAD_BETS');
        if (localBets) {
            localBets = JSON.parse(localBets);
            if (isPlacedBetsElseSettled !== undefined) {
                let currBets = isPlacedBetsElseSettled
                    ? localBets.placedBets
                    : localBets.settledBets;

                currBets = currBets.map((cBet) => {
                    if (cBet.Bets.find((bet) => bet.Channel === gameChannel)) {
                        cBet.isRead = true;
                    }
                    return cBet;
                });

                if (isPlacedBetsElseSettled) {
                    localBets.placedBets = currBets;
                } else {
                    localBets.settledBets = currBets;
                }
            } else {
                if (state.isBetHistoryOpen) {
                    let currBets = state.selectedBetHistoryTab === ACTIVE_BETS_TAB
                        ? localBets.placedBets
                        : localBets.settledBets;

                    currBets = currBets.map((cBet) => {
                        if (cBet.Bets.find((bet) => bet.Channel === state.selectedBetHistoryGame)) {
                            cBet.isRead = true;
                        }
                        return cBet;
                    });

                    if (state.selectedBetHistoryTab === ACTIVE_BETS_TAB) {
                        localBets.placedBets = currBets;
                    } else {
                        localBets.settledBets = currBets;
                    }
                }
            }
            sessionStorage.setItem('UNREAD_BETS', JSON.stringify(localBets));
        }
    }
}



// WEBPACK FOOTER //
// ./src/ui-modules/simplified/helpers/betHistoryHelpers.js